import { type ZodiosPlugin } from "@zodios/core";

export function logRequests(): ZodiosPlugin {
  return {
    name: "logRequests",
    request: async function (_api, config) {
      try {
        const t0 = Date.now();
        const { method, url } = config;
        console.info(`HTTP ${method.toUpperCase()} ${url} ...`);
        const intervalId = setInterval(() => {
          const dt = Math.round((Date.now() - t0) / 1000);
          console.info(`No response from ${url} after ${dt} s`);
        }, 1000);
        (config as any).logRequestsData = { t0, intervalId };
      } catch (error) {
        console.error(error);
      }
      return config;
    },
    response: async function (_api, config, response) {
      try {
        const { t0, intervalId } = (config as any).logRequestsData;
        clearInterval(intervalId);
        const { method, url } = config;
        const dt = Date.now() - t0;
        const duration = dt > 5000 ? `${Math.round(dt / 1000)} s` : `${dt} ms`;
        console.info(`HTTP ${method.toUpperCase()} ${url} => ${response.status} after ${duration}`);
      } catch (error) {
        console.error(error);
      }
      return response;
    },
    error: async function (_api, config, error) {
      try {
        const { logRequestsData } = config as any;
        if (logRequestsData) {
          const { t0, intervalId } = logRequestsData;
          clearInterval(intervalId);
          const { method, url } = config;
          const dt = Date.now() - t0;
          const duration = dt > 5000 ? `${Math.round(dt / 1000)} s` : `${dt} ms`;
          console.warn(`HTTP ${method.toUpperCase()} ${url} failed after ${duration}`);
        }
      } catch (error) {
        console.error(error);
      }
      throw error;
    },
  };
}
